export default __webpack_public_path__ + "images/bee_ok.290c2f2.png";